import { createSelector } from 'reselect';

const selectAdminLevelTwo = (state: any) => state.AdminLevelTwo;


export const selectAdminLevelTwoCurrentItem = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.current);

export const selectAdminLevelTwoListItems = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAdminLevelTwoListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAdminLevelTwoQueryItems = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.query);

export const selectAdminLevelTwoCreatedItem = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.create);

export const selectAdminLevelTwoUpdatedItem = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.update);

export const selectAdminLevelTwoReadItem = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.read);

export const selectAdminLevelTwoDeletedItem = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.delete);

export const selectAdminLevelTwoSearchedItems = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.search);

export const selectAdminLevelTwoItemsCount = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.count);

export const selectAdminLevelTwoItemsFilter = createSelector([selectAdminLevelTwo], (AdminLevelTwo) => AdminLevelTwo.filter);